/*@flow*/
import mkString from './mkString';

export default (mkString(): $FlowFixMe);
